import { render, staticRenderFns } from "./RespuestasComponent.vue?vue&type=template&id=4b9c6d1b"
import script from "./RespuestasComponent.vue?vue&type=script&lang=js"
export * from "./RespuestasComponent.vue?vue&type=script&lang=js"
import style0 from "./RespuestasComponent.vue?vue&type=style&index=0&id=4b9c6d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports